(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function loadMoreNews() {
  return {
    loadMoreButton: document.getElementById('load-more-news'),
    newsPosts: document.querySelector('.news-posts'),
    loader: document.getElementById('news-loader'),
    init: function init() {
      this.formatYears();
      this.loadMore();
    },
    loadMore: function loadMore() {
      var that = this;
      that.loadMoreButton.addEventListener('click', function () {
        var offset = that.newsPosts.getAttribute('data-loaded');
        var termId = that.newsPosts.getAttribute('data-term');
        that.loader.style.display = 'block';
        var xhr = new XMLHttpRequest();

        xhr.onload = function () {
          if (this.readyState == 4 && this.status == 200) {
            var results = JSON.parse(xhr.response);

            if (results.posts) {
              that.newsPosts.insertAdjacentHTML('beforeend', results.posts);
              that.newsPosts.setAttribute('data-loaded', parseInt(offset) + 6);
              that.formatYears();
            }

            if (!results.more_posts) {
              that.newsPosts.insertAdjacentHTML('afterend', results.message); //that.loadMoreButton.disabled = true;

              that.loadMoreButton.parentNode.removeChild(that.loadMoreButton);
            }
          }

          that.loader.style.display = 'none';
        };

        xhr.open('GET', '/wp-json/news/v1/load-more?offset=' + offset + '&term=' + termId);
        xhr.send();
      });
    },
    formatYears: function formatYears() {
      var allArticles = document.querySelectorAll('.news-article'); //get list of all years

      var years = [];
      allArticles.forEach(function (item) {
        var itemYear = item.getAttribute('data-year');

        if (itemYear !== '' && !years.includes(itemYear)) {
          years.push(item.getAttribute('data-year'));
        }
      });
      years.forEach(function (year) {
        var firstItem = document.querySelector('.news-article[data-year="' + year + '"]');

        if (!firstItem.classList.contains('year-start')) {
          firstItem.classList.add('year-start');
        }
      });
    }
  };
}

var newsPage = loadMoreNews();
newsPage.init();

},{}]},{},[1]);
